









































import {Vue, Component} from 'vue-property-decorator';
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import dataProxy from '@/services/data-proxy.service';
import {NovaLozinka} from "@/services/BackendProxies";

@Component
export default class MojProfil extends mixins(ComponentBaseMixin) {
    novaLozinka = '';
    potvrdaLozinke = '';

    async promenaLozinke() {
        const ok = await this.saveData(() => dataProxy.promeniMojuLozinku(NovaLozinka.fromJS({lozinka: this.novaLozinka})))();
        if (ok) {
            this.showInfo('vasa lozinka je uspesno promenjena');
        }
    }
}
